<template>
  <v-list-tile
    class="nx-entity-list-editor-item"
    :class="{ sortable, cloneable }"
    :key="item.id"
    :target="target"
    :to="editorRoute"
    :event="openModalEditor ? '' : 'click'"
    @click.stop="$emit('click')"
    ripple>
    <v-list-tile-content>
      <nx-list-item
        normal
        :selectable="openModalEditor"
        :site-id="item.siteId"
        @click:item.prevent="$emit('click')"
        v-bind="item.list"
        class="mb-0">
        <template v-slot:actions>
          <v-tooltip left v-if="cloneable">
            <v-btn icon flat
                   @click.stop.prevent="$emit('clone')"
                   :disabled="disabled"
                   class="ma-0"
                   slot="activator" color="primary">
              <v-icon>control_point_duplicate</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.clone')"></span>
          </v-tooltip>
          <v-tooltip left v-if="deletable">
            <v-btn icon flat
                   class="mr-0 my-0 ml-1"
                   @click.stop.prevent="$emit('remove')"
                   :disabled="disabled"
                   slot="activator" color="primary">
              <v-icon>delete</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.delete')"></span>
          </v-tooltip>
        </template>
      </nx-list-item>
    </v-list-tile-content>

    <v-list-tile-action>
        <v-layout column justify-space-around align-center class="nx-primary--lighten-4 py-1 fill-height">
          <v-tooltip bottom v-if="sortable">
            <v-btn icon flat :disabled="disabled"
                   @click.stop.prevent="$emit('moveUp')"
                   slot="activator" color="primary">
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveUp')"></span>
          </v-tooltip>
          <v-tooltip bottom v-if="sortable">
            <v-btn icon flat :disabled="disabled"
                   @click.stop.prevent="$emit('moveDown')"
                   slot="activator" color="primary">
              <v-icon>arrow_downward</v-icon>
            </v-btn>
            <span v-html="$t('message.relation.moveDown')"></span>
          </v-tooltip>
        </v-layout>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { entityEditorRoute } from '@/modules/entity/router';
import NxListItem from '@/components/list/components/ListItem';

export default {
  name: 'nx-entity-list-editor-item',
  components: { NxListItem },
  props: {
    entity: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    sortable: {
      type: Boolean,
    },
    cloneable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    openModalEditor: {
      type: Boolean,
    },
    target: {
      type: String,
      default: '_self',
    },
    deletable: Boolean,
  },
  computed: {
    editorRoute() {
      return entityEditorRoute.get(this.entity, this.item);
    },
  },
};
</script>
